import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

export interface Step {
  name: string
  current: boolean
  complete: boolean
  step: number
}

@Injectable({
  providedIn: 'root',
})
export class StepperService {
  private stepSubject = new BehaviorSubject<Step | null>(null)
  private stepsSubject = new BehaviorSubject<Step[]>([])

  setStep(step: Step): void {
    this.stepSubject.next(step)
  }

  getStep(): Observable<Step | null> {
    return this.stepSubject.asObservable()
  }

  setSteps(steps: Step[]): void {
    this.stepsSubject.next(steps)
  }

  getSteps(): Observable<Step[]> {
    return this.stepsSubject.asObservable()
  }

  select(step: Step): void {
    const steps = this.stepsSubject.getValue()
    steps.forEach((s) => (s.current = false))
    step.current = true
    this.stepSubject.next(step)
    this.stepsSubject.next(steps)
  }

  back(): void {
    const steps = this.stepsSubject.getValue()
    const currentIndex = steps.findIndex((s) => s.current)
    if (currentIndex > 0) {
      steps[currentIndex].current = false
      steps[currentIndex - 1].current = true
      this.stepSubject.next(steps[currentIndex - 1])
      this.stepsSubject.next(steps)
    }
  }

  next(): void {
    const steps = this.stepsSubject.getValue()
    const currentIndex = steps.findIndex((s) => s.current)
    if (currentIndex < steps.length - 1) {
      steps[currentIndex].current = false
      steps[currentIndex].complete = true
      steps[currentIndex + 1].current = true
      this.stepSubject.next(steps[currentIndex + 1])
      this.stepsSubject.next(steps)
    }
  }
}
